import { Deserializable } from '../../../protocols/deserializable';

/**
 * Precomputed server-side recommendation ranking for a single variant at a location.
 *
 * `order` represents the complete server-side ranking logic (recommendation signals, company/global score
 * weighting, sponsored boosts, availability, stock position, and deterministic tiebreaking). The client sorts
 * using `order` ascending and must NOT reproduce any of the ranking math locally. The score fields below are
 * informational only.
 *
 * Note: the rankings endpoint only returns products currently carried by the location (in stock, or out of stock
 * for no more than 30 days). Company catalog products the location has never stocked will have no Ranking row.
 */
export class Ranking implements Deserializable {
  public variantId: string;
  public bpdId: string;
  public brandNameId: string;

  /**
   * Informational only. Company recommendation score, weighted at 2x the global score by the backend.
   */
  public companyScore: number;

  /**
   * Informational only. Global (network wide) recommendation score. Requires at least 5 signals from at least
   * 2 distinct contributors, so this may be 0 across the board until sufficient network activity exists.
   */
  public globalScore: number;

  /**
   * Informational only. Backend computed blend of company and global scores.
   */
  public effectiveScore: number;

  /**
   * Informational only. Currently Canada specific - 0 for US locations.
   */
  public availabilityScore: number;

  /**
   * Informational only. Sponsored boost behaviour is not currently active, so this is expected to remain false.
   */
  public isBoosted: boolean;

  /**
   * The only field the client sorts on. Ascending. A missing Ranking row must never be treated as order 0.
   */
  public order: number;

  onDeserialize(): void {}
}
